"use client";

import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import type { FAQItem } from "@/lib/courses";

export function CourseFAQ({ items }: { items: FAQItem[] }) {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="divide-y divide-cb-border rounded-xl border border-cb-border overflow-hidden">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className={`transition-colors duration-200 ${isOpen ? "bg-cb-surface-2" : "bg-cb-surface hover:bg-cb-surface-2"}`}>
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
              aria-expanded={isOpen}
            >
              <span className={`text-sm font-semibold leading-snug transition-colors duration-200 min-w-0 ${isOpen ? "text-cb-text" : "text-cb-muted"}`}>
                {item.question}
              </span>
              <span className="shrink-0 text-cb-blue">
                {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
              </span>
            </button>

            <div
              className="overflow-hidden transition-all duration-300 ease-in-out"
              style={{ maxHeight: isOpen ? "400px" : "0px", opacity: isOpen ? 1 : 0 }}
            >
              <div className="px-6 pb-5 text-base text-cb-muted leading-relaxed">
                <p>{item.answer}</p>
                {item.link && (
                  <a
                    href={item.link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-3 inline-flex min-h-11 items-center font-semibold text-cb-blue underline underline-offset-4 hover:text-cb-text active:text-cb-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cb-blue rounded-sm"
                  >
                    {item.link.label}
                  </a>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
